import _mapVueRoutes from './mapVueRoutes'

/**
 * Singleton Class for making a VueJS router instance using an asyncronous
 * fetch to build a dynamic list of routes.
 * This class must be used to create the router _before_ the
 * Vue instance gets initialized.
 *
 * Three public functions:
 * - setRouterData(): saves data from the API as instance.#routerData
 * - getRouterData(): gets said data
 * - getVueRouterConfig(): creates a config object for vue-router
 *
 * One public field:
 * - routerDataMixin: A VueJS mixin to provide access to getRouterData()
 *
 * Can only be used once to prevent multiple calls to the backend,
 * and potentially mix-matched router data between components.
 */

class DSRouter {
  #routerData = null;
  routerDataMixin = {
    methods: { getRoutesData: () => this.getRouterData() },
  }

  constructor() {
    if(!DSRouter.instance){
      DSRouter.instance = this;
    }
    return DSRouter.instance;
  }

  /**
   * Sets the instance's router data.
   * @return {Array} [description]
   */
  setRouterData(routerData) {
    this.#routerData = routerData
  }

  /**
   * Gets the instance's router data.
   * @return {Array} [description]
   */
  getRouterData() {
    return this.#routerData
  }

  /**
   * Creates and returns a vue-router configuration object
   * used when creating a new vue-router instance.
   * Also adds a default route used when
   * the url isn't matched to a defined route.
   * (This includes '/')
   * @param  {Array} routerData A list of pages from which to build the routes from
   * @return {Object}           A vue-router configuration object
   */
  getVueRouterConfig() {
    if (this.__isMissingData()) return
    const routes = _mapVueRoutes(this.#routerData)
    routes.push({ path: '*', redirect: routes[0].path })
    return {
      mode: 'history',
      base: '/awards',
      scrollBehavior (to, from) {
        if(to.name === "About") {
          return false
        }
        window.scrollTo({
          top: document.getElementById('PurpleRibbonPage').offsetTop,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });

      },
      routes,
    }
  }
  /**
   * Checks to see if the router data is available
   * Used to prevent errors if the router data has not been fetched yet.
   * @return {Boolean} True if data is missing, false if data has been fetched
   */
  __isMissingData() {
    if (this.#routerData === null) {
      //console.warn('this.routerData is null. Call setRouterData(data) first.')
    }
    return this.#routerData === null
  }
}

const DSRouterInstance = new DSRouter()
export default DSRouterInstance
